export default __webpack_public_path__ + "static/illu-my-property-f38dd31866a5ddee32625605e3af0966.png";